import { useState } from "react";

import FormRow from "./FromRow.component";
import { Button } from "react-bootstrap";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { editUserRole } from "../../services/admin.service";

function EditRole({ name, role, onCloseModal, id, onConfirm }) {
  const [selectedRole, setSelectedRole] = useState(role);
  const queryClient = useQueryClient();

  const handleSelectChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const { isPending: isEditing, mutate: editRole } = useMutation({
    mutationFn: () => editUserRole(id, selectedRole),
    onSuccess: () => {
      queryClient.invalidateQueries(["allusers"]);
      toast.success("Role Edited successfully");
    },
    onError: (err) => {
      console.log(err);
      toast.error("Couldn't Edit this user role");
    },
  });

  return (
    <div className="styled-small-popup">
      <h3>Edit role for - {name}</h3>
      <FormRow label="Role ">
        <select className="form-select" value={selectedRole} onChange={handleSelectChange}>
          <option value="admin">Admin</option>
          <option value="user">User</option>
        </select>
      </FormRow>
      <div>
        <Button variant="outline-dark" disabled={isEditing} onClick={onCloseModal}>
          Cancel
        </Button>
        <Button variant="success" disabled={isEditing} onClick={editRole}>
          Confrim
        </Button>
      </div>
    </div>
  );
}

export default EditRole;
